import { useDocumentTitle } from 'usehooks-ts';

export type IUpdateDomTitle = {
  updateTitle: (title: string) => void;
};

export default function useUpdateDomTitle(title: string): IUpdateDomTitle {
  useDocumentTitle(title);

  const updateTitle = (newTitle: string): void => {
    window.document.title = newTitle;
  };

  return {
    updateTitle
  };
}
